import { render, staticRenderFns } from "./CommonPop.vue?vue&type=template&id=1954b2ca&scoped=true&"
import script from "./CommonPop.vue?vue&type=script&lang=ts&"
export * from "./CommonPop.vue?vue&type=script&lang=ts&"
import style0 from "./CommonPop.vue?vue&type=style&index=0&id=1954b2ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1954b2ca",
  null
  
)

export default component.exports